import React from "react";
import { Table, Popover } from "antd";
import { transactionTableHead } from "../data";
import { transactionData } from "./transactionData";

export const TransactionListData = ({ transactions = [] }) => {
    const dataToDisplay = transactions.length > 0 ? transactions : transactionData;

    if (!dataToDisplay || dataToDisplay.length === 0) {
        return (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "36px" }}>
                <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                    No payout statements for this ride yet.
                </p>
            </div>
        );
    }

    const tableHeaderStyles = {
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "100%",
        height: "19px",
        color: "#656574"
    }

    const tableDataStyles = {
        height: "18px",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "125%",
        letterSpacing: "0.25%",
        color: "#060606",
    }

    const columns = transactionTableHead.map((column) => {
        switch (column.title) {
            case "Payout Date And Time":
                return {
                    title: <span style={tableHeaderStyles}>{column.title}</span>,
                    dataIndex: "payoutDate",
                    key: "payoutDate",
                    width: column.width,
                    render: (text) => <span style={tableDataStyles}>{text || "N/A"}</span>,
                };

            // case "Transaction Id":
            //     return {
            //         title: <span style={tableHeaderStyles}>{column.title}</span>,
            //         dataIndex: "transactionId",
            //         key: "transactionId",
            //         width: column.width,
            //         render: (text) => {
            //             if (!text) return <span style={tableDataStyles}>N/A</span>;

            //             const truncatedText = text.length > 22
            //                 ? `${text.substring(0, 22)}...`
            //                 : text;

            //             return <span style={tableDataStyles}>{truncatedText}</span>;
            //         },
            //     };

            case "Transaction Id":
                return {
                    title: <span style={tableHeaderStyles}>{column.title}</span>,
                    dataIndex: "transactionId",
                    key: "transactionId",
                    width: column.width,
                    render: (text) => {
                        if (!text) return <span style={tableDataStyles}>N/A</span>;

                        const truncatedText = text.length > 22
                            ? `${text.substring(0, 22)}...`
                            : text;

                        // Only show popover if text is truncated
                        if (text.length > 22) {
                            return (
                                <Popover
                                    content={
                                        <div style={{ maxWidth: 300, wordBreak: 'break-all', fontSize: '12px' }}>
                                            {text}
                                        </div>
                                    }
                                    trigger="hover"
                                >
                                    <span style={{ ...tableDataStyles }}>
                                        {truncatedText}
                                    </span>
                                </Popover>
                            );
                        }

                        return <span style={tableDataStyles}>{truncatedText}</span>;
                    },
                };

            case "Pay Mode":
                return {
                    title: <span style={tableHeaderStyles}>{column.title}</span>,
                    dataIndex: "payMode",
                    key: "payMode",
                    width: column.width,
                    render: (text) => <span style={tableDataStyles}>{text || "N/A"}</span>,
                };

            case "Status":
                return {
                    title: <span style={tableHeaderStyles}>{column.title}</span>,
                    dataIndex: "status",
                    key: "status",
                    width: column.width,
                    render: (text) => <span style={tableDataStyles}>{text || "N/A"}</span>
                };

            case "Amount Paid":
                return {
                    title: <span style={tableHeaderStyles}>{column.title}</span>,
                    dataIndex: "amountPaid",
                    key: "amountPaid",
                    width: column.width,
                    render: (text) => <span style={tableDataStyles}>{text || "N/A"}</span>,
                };

            default:
                return null;
        }
    });

    const validColumns = columns.filter(column => column !== null);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px"
            }}
        >
            <div
                style={{
                    backgroundColor: "#f5f6fa",
                    borderRadius: "8px",
                    overflow: "hidden",
                    width: "100%",
                }}
            >
                <Table
                    dataSource={dataToDisplay.map((transaction, index) => ({
                        ...transaction,
                        key: transaction.transactionId || index
                    }))}
                    columns={validColumns}
                    pagination={false}
                    bordered={false}
                    rowClassName={(record, index) =>
                        index % 2 === 0 ? "table-row-light" : "table-row-dark"
                    }
                    style={{ border: "none", }}
                />
            </div>

            <style>
                {`
                .ant-table-thead > tr > th {
                    background-color: #f5f6fa !important; 
                    font-weight: 600 !important;
                    text-align: left !important;
                    padding: 16px !important;
                    border-bottom: none !important; 
                    font-size: 16px !important;
                    color: #595959 !important;
                }

                .table-row-light > td {
                    background-color: white !important;
                    padding: 16px !important;
                    border-bottom: 1px solid #f0f0f0 !important;
                }

                .table-row-dark > td {
                    background-color: #fafafa !important;
                    padding: 16px !important;
                    border-bottom: 1px solid #f0f0f0 !important;
                }

                .ant-table-tbody > tr:last-child > td {
                    border-bottom: none !important;
                }

                .ant-table-tbody > tr:hover > td {
                    background-color: #e6f7ff !important;
                }

                .ant-tag {
                    font-size: 12px !important;
                    padding: 4px 8px !important;
                    border-radius: 4px !important;
                    font-weight: 500 !important;
                }
            `}
            </style>

        </div>
    );
};
